import { focalPointApiURL } from 'Constants/Constants';
import axios from 'axios';

const focalPointApiClient = axios.create({
    baseURL: focalPointApiURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export default focalPointApiClient;
